<template>
  <div class="WinTheBid">
    <h2>{{this.dataList.tenderTitle}}</h2>
        <div class="detail">
          <span>发布时间:{{this.dataList.createTime}}</span>
          <span>发布人:{{this.dataList.operatorName}}</span>
        </div>
        <div class="introduce">
          <span
            >&#12288&#12288 {{this.dataList.others}}</span
          >
        </div>
        <div class="table">
          <h4>中标候选人详情</h4>
          <table-page :data="tableData" :columns="columns" :border="true">
          </table-page>
        </div>
      <!-- 报名时间 -->
      <!-- <div class="RegistrationTime">
        <div class="LProductIntroductionItem">
          <span>报名截止时间</span>
          <el-date-picker
            v-model="form.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请输入审批时间"
          >
          </el-date-picker>
        </div>
      </div> -->
        <!-- 相关附件 -->
        <div class="RelatedAnnex">
          <div class="ProductIntroduction">
            <span class="title">相关附件</span>
            <!-- <div class="content">
                  <i class="el-icon-upload2"></i>
            </div> -->
            <div class="UpDoc">
              <div class="UpDocTitle">
                <li v-for="(item, index) in fileList" :key="index" @click="Download(item)">
                  {{ item.FilesName }}
                </li>

              </div>

            </div>
          </div>
        </div>

  </div>
</template>

<script>
import { download } from "@/api/ChargeUp";
import TablePage from "@/components/table/CallForBids-page";
import { selectDetailSuccessful } from "@/api/CollectivePurchase";
import { WinTheBid } from "../../memberCenter/CollectionMining/tableColumn";

export default {
  name: "NowWinTheBid",

  data() {
    return {
      columns: WinTheBid,
      tableData: [],
      dataList: [],
      form: {
        endTime: "",
      },
      fileList: [],
    };
  },
  components: {
    TablePage,
  },
  mounted() {
    this.selectDetailSuccessful();
  },

  methods: {
    async selectDetailSuccessful() {
      let winnerId = this.$route.query.data;
      let params = winnerId;
      console.log(params);
      let res = await selectDetailSuccessful(params);
      this.dataList = res.data;
      this.tableData = res.data.newAgriculturalVoList;
      this.form.endTime = res.data.endTime;
      this.fileList = JSON.parse(res.data.files);
    },
    //下载
    async Download(file) {
      let itemList = file;
      let res = await download({ ossFilePath: itemList.imgUrl });
      if (res) {
        let blob = res;

        let ToName = itemList.FilesName;
        const fileName = ToName;
        let downloadElement = document.createElement("a");
        let binaryData = [];
        binaryData.push(blob);
        // "|.doc,.docx,.xls,.xlsx,.pdf,.zip,.7z"
        let href = window.URL.createObjectURL(
          new Blob(binaryData, {
            type: "application/pdf||doc||docx||xls||xlsx||zip||7z",
          })
        ); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = decodeURIComponent(fileName); //解码
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      }
    },
  },
};
</script>
<style lang="less">
.WinTheBid {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  text-align: left;
  padding-bottom: 128px;
  h2 {
    text-align: center;
  }
  .detail {
    display: flex;
    justify-content: space-around;
    span {
      font-size: 18px;
    }
  }
  .introduce {
    height: 60px;
    width: 97%;
    margin: 0 auto;
    margin-top: 10px;
  }
  .table {
    width: 100%;
    margin-top: 5px;
    border-top: 2px solid #1ea84d;
    h4 {
      margin: 5px 10px;
    }
    table {
      width: 97%;
      margin: 0 auto;
      margin-top: 20px;
      border-collapse: collapse;
      text-align: center;

      tr {
        td {
          padding: 5px 5px;
        }
      }
    }
  }
  .information {
    table {
      width: 97%;
      margin: 0 auto;
      margin-top: 20px;
      border-collapse: collapse;
      text-align: center;
      tr {
        td {
          padding: 5px 5px;
        }
      }
    }
  }

  .ProductIntroduction {
    width: 80%;
    height: 50px;
    display: flex;
    padding-bottom: 10px;
    padding-left: 20px;
    span {
      width: 150px;
      font-weight: bold;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
  .ContributionRatio {
    width: 80%;
    height: 50px;
    display: flex;
    padding-bottom: 10px;
    padding-left: 20px;
    span {
      width: 127px;
      font-weight: bold;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    .el-input {
      width: 100px;
    }
    .w {
      padding-left: 10px;
    }
  }
  .RelatedAnnex {
    margin-top: 20px;
    .ProductIntroduction {
      width: 80%;
      height: 50px;
      display: flex;
      padding-bottom: 10px;
      .title {
        width: 150px;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
      .content {
        .el-icon-upload2 {
          font-size: 50px;
          font-weight: bold;
        }
      }
      .UpDoc {
        padding-left: 20px;
        .UpDocTitle {
          padding-top: 10px;
          display: flex;
          list-style: none;
          li {
            padding: 0px 8px;
            text-decoration: underline;
          }
        }
        .Tips {
          padding-top: 10px;
          color: #ec808d;
        }
      }
    }
  }
  .RegistrationTime {
    padding-left: 20px;
    display: flex;
    .LProductIntroductionItem {
      padding-top: 20px;
      .el-date-editor {
        margin-left: 20px;
      }
      span {
        font-weight: bold;
        display: inline-block;
      }
    }
  }
}
</style>
